"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContentEditFeatures_1 = require("./ContentEditFeatures");
var autoLinkFeatures_1 = require("./features/autoLinkFeatures");
var shortcutFeatures_1 = require("./features/shortcutFeatures");
var insertLineBeforeStructuredNodeFeature_1 = require("./features/insertLineBeforeStructuredNodeFeature");
var noCycleCursorMove_1 = require("./features/noCycleCursorMove");
var tableFeatures_1 = require("./features/tableFeatures");
var markdownFeatures_1 = require("./features/markdownFeatures");
var listFeatures_1 = require("./features/listFeatures");
var quoteFeatures_1 = require("./features/quoteFeatures");
/**
 * An editor plugin to handle content edit event.
 * The following cases are included:
 * 1. Auto increase/decrease indentation on Tab, Shift+tab
 * 2. Enter, Backspace on empty list item
 * 3. Enter, Backspace on empty blockquote line
 * 4. Auto bullet/numbering
 * 5. Auto link
 * 6. Tab in table
 * 7. Up/Down in table
 * 8. Manage list style
 */
var ContentEdit = /** @class */ (function () {
    /**
     * Create instance of ContentEdit plugin
     * @param features An optional feature set to determine which features the plugin should provide
     */
    function ContentEdit(featureSet) {
        this.featureSet = featureSet;
    }
    /**
     * Get a friendly name of  this plugin
     */
    ContentEdit.prototype.getName = function () {
        return 'ContentEdit';
    };
    /**
     * Initialize this plugin
     * @param editor The editor instance
     */
    ContentEdit.prototype.initialize = function (editor) {
        var _this = this;
        this.editor = editor;
        this.getFilteredFeatures().forEach(function (feature) { return _this.editor.addContentEditFeature(feature); });
    };
    /**
     * Dispose this plugin
     */
    ContentEdit.prototype.dispose = function () {
        this.editor = null;
    };
    ContentEdit.prototype.getFilteredFeatures = function () {
        var featureSet = this.featureSet || ContentEditFeatures_1.getDefaultContentEditFeatures();
        var allFeatures = {
            indentWhenTab: listFeatures_1.IndentWhenTab,
            outdentWhenShiftTab: listFeatures_1.OutdentWhenShiftTab,
            outdentWhenBackspaceOnEmptyFirstLine: listFeatures_1.OutdentWhenBackOn1stEmptyLine,
            outdentWhenEnterOnEmptyLine: listFeatures_1.OutdentWhenEnterOnEmptyLine,
            mergeInNewLineWhenBackspaceOnFirstChar: listFeatures_1.MergeInNewLine,
            unquoteWhenBackspaceOnEmptyFirstLine: quoteFeatures_1.UnquoteWhenBackOnEmpty1stLine,
            unquoteWhenEnterOnEmptyLine: quoteFeatures_1.UnquoteWhenEnterOnEmptyLine,
            tabInTable: tableFeatures_1.TabInTable,
            upDownInTable: tableFeatures_1.UpDownInTable,
            insertLineBeforeStructuredNodeFeature: insertLineBeforeStructuredNodeFeature_1.InsertLineBeforeStructuredNodeFeature,
            autoBullet: listFeatures_1.AutoBullet,
            autoLink: autoLinkFeatures_1.AutoLink,
            unlinkWhenBackspaceAfterLink: autoLinkFeatures_1.UnlinkWhenBackspaceAfterLink,
            defaultShortcut: shortcutFeatures_1.DefaultShortcut,
            noCycleCursorMove: noCycleCursorMove_1.NoCycleCursorMove,
            smartOrderedList: listFeatures_1.getSmartOrderedList(featureSet.smartOrderedListStyles),
            markdownBold: markdownFeatures_1.MarkdownBold,
            markdownItalic: markdownFeatures_1.MarkdownItalic,
            markdownStrikethru: markdownFeatures_1.MarkdownStrikethru,
            markdownInlineCode: markdownFeatures_1.MarkdownInlineCode,
        };
        var keys = Object.keys(allFeatures);
        return keys.filter(function (key) { return featureSet[key]; }).map(function (key) { return allFeatures[key]; });
    };
    return ContentEdit;
}());
exports.default = ContentEdit;
//# sourceMappingURL=ContentEdit.js.map